
export const BRANDS = [
  'visa',
  'master',
  'elo',
  'amex',
  'diners',
  'hipercard'
]

export const BRAND_OPTIONS = [
  { value: '', label: 'Todas' },
  ...BRANDS.map((brand) => {
    return {
      value: brand,
      label: brand.charAt(0).toUpperCase() + brand.slice(1).replace('-', ' ')
    }
  })
]
